import React from "react";
import Button from "@edaz/edazkit/Button/index";
import { preventDefault } from "@frui.ts/views/dist";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RoleDetailViewModel from "viewModels/users/roles/detail/roleDetailViewModel";
import RoleForm from "../roleForm";
import { RoleUsersListView } from "./roleUsersListView";
import HeaderWithBackButton from "components/headerWithBackButton";
import { RoleUserCreateView } from "./roleUserCreateView";
import { IconType } from "@edaz/edazkit/Icon";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { ButtonToolbar, Form } from "react-bootstrap";

export const RoleDetailView: ViewComponent<RoleDetailViewModel> = observer(({ vm }) => {
  const actionButton = (
    <Button className="rounded" size="sm" iconLeft={IconType.SignPlus} onClick={vm.onAddUserClick}>
      {vm.translate("addUser")}
    </Button>
  );

  return (
    <>
      <HeaderWithBackButton
        className="mb-4"
        title={vm.name}
        back={{ link: vm.backLink, action: vm.close }}
        actionButton={actionButton}
      />
      <LoaderOverlay loading={vm.roleUpdateViewModel.busyWatcher.isBusy}>
        <Form className="mb-4" onSubmit={preventDefault(vm.roleUpdateViewModel.save)}>
          <RoleForm vm={vm.roleUpdateViewModel} />
          <ButtonToolbar className="justify-content-center">
            <Button size="sm" onClick={vm.close} type="reset" variant="light">
              {vm.roleUpdateViewModel.translateGeneral("cancel")}
            </Button>
            <Button size="sm" type="submit" disabled={vm.roleUpdateViewModel.busyWatcher.isBusy}>
              {vm.roleUpdateViewModel.translateGeneral("save")}
            </Button>
          </ButtonToolbar>
        </Form>
      </LoaderOverlay>
      <RoleUsersListView vm={vm.roleUsersListViewModel} />
      <RoleUserCreateView vm={vm.roleUserCreateViewModel} />
    </>
  );
});

registerView(RoleDetailView, RoleDetailViewModel);
